export const Copy = {
  title: "Medical Concerns",
  description: {
    minor: "Indicate any medical concerns that apply to the minor.",
    self: "Indicate any medical concerns that apply to you.",
  },
};
